<template>
    <div class="section-label" :style="{width: size, backgroundColor: bg_color}">
        <slot></slot>
    </div>
</template>

<script>
export default {
  name : 'LabelTopic',
  props: {
    bg_color: {
      type: String,
    },
    small: {
      type: Boolean,
    },
  },
  computed: {
    size() {
      return this.small ? '100%' : '160px';
    },
  },
};
</script>
